import SettingsApiKeys from '@/components/settings/pages/SettingsApiKeys';

export const Route = createFileRoute({
	component: SettingsApiKeys,
});
